<template>
  <b-container>
    <b-row>
      <b-col v-if="RoleID ==2" md="10">
        <form class="mt-3">
          <div class="form-row">
            <!-- <div class="form-group col-md-5">
                      <label for="ipLoanType">Scheme Name</label>
                      <select id="ipLoanType" class="form-control" :options="schemes" v-model="selectedScheme">
                      </select>
            </div>-->
            <div class="form-group col-md-3">
              <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="2"
                label="District"
                label-for="ipDistrict"
                label-size="sm"
              >
                <b-select
                  id="ipDistrict"
                  :options="districts"
                  value-field="DistID"
                  text-field="DistName"
                  required
                  size="sm"
                  :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
                  v-model="selectedDistrict"
                  @change.native="onChangeDistrict"
                  class="form-control"
                ></b-select>
              </b-form-group>
            </div>
            <div class="form-group col-md-5"></div>
          </div>
        </form>
        <b-card class="mb-3 shadow-sm dashboard-stats-card" body-class="py-3 px-3">
          <template v-slot:header>
            <b-row class="no-gutters align-items-center">
              <b-col>
                <strong>Corporation Scheme Statistics</strong>
              </b-col>
              <b-col class="text-right">
                <small class="text-muted">All schemes implemented by the Corporation</small>
              </b-col>
            </b-row>
          </template>

          <div v-if="schemeStatsLoading" class="text-center py-3">
            <b-spinner small></b-spinner> Loading scheme statistics...
          </div>

          <b-row v-else>
            <b-col md="3" class="mb-2">
              <div class="stat-title">Scheme-wise</div>
              <div v-for="row in schemeStats.schemeWise" :key="'scheme-' + row.label" class="stat-row">
                {{ row.label }}: {{ row.count }}
              </div>
            </b-col>
            <b-col md="3" class="mb-2">
              <div class="stat-title">Application Status-wise</div>
              <div v-for="row in schemeStats.applicationStatusWise" :key="'status-' + row.label" class="stat-row">
                {{ row.label }}: {{ row.count }}
              </div>
            </b-col>
            <b-col md="3" class="mb-2">
              <div class="stat-title">Category-wise</div>
              <div v-for="row in schemeStats.categoryWise" :key="'category-' + row.label" class="stat-row">
                {{ row.label }}: {{ row.count }}
              </div>
            </b-col>
            <b-col md="3" class="mb-2">
              <div class="stat-title">Claims</div>
              <div class="stat-row">
                Old Claims: {{ schemeStats.claimSplit.oldCount }}
                ({{ formatAmount(schemeStats.claimSplit.oldAmount) }})
              </div>
              <div class="stat-row">
                New Claims: {{ schemeStats.claimSplit.newCount }}
                ({{ formatAmount(schemeStats.claimSplit.newAmount) }})
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="mb-3 shadow-sm dashboard-stats-card" body-class="py-3 px-3">
          <template v-slot:header>
            <b-row class="no-gutters align-items-center">
              <b-col>
                <strong>Main Company and Subsidiary Statistics</strong>
              </b-col>
              <b-col class="text-right">
                <small class="text-muted">Separate breakdown aligned with company statistics</small>
              </b-col>
            </b-row>
          </template>

          <div v-if="companyStatsLoading" class="text-center py-3">
            <b-spinner small></b-spinner> Loading company-wise statistics...
          </div>
          <b-table
            v-else
            small
            bordered
            striped
            hover
            head-variant="light"
            :items="companyStatsRows"
            :fields="companyStatsFields"
            empty-text="No company-wise statistics available."
            style="font-size:12px"
          ></b-table>
        </b-card>
        <b-row>
          <b-col md="6">
            <b-table
              show-empty
              head-variant="dark"
              empty-text="No Applications available."
              stacked="md"
              bordered
              striped
              :items="appsummary"
              :fields="fields"
              style="font-size:12px"
            >
              <template v-slot:cell(TotalIndividual)="row">
                <b-button
                  size="sm"
                  @click.stop="viewDetailsIR(row.item, 0)"
                  class="mr-1 pt-0 pb-0"
                  variant="link"
                >{{row.item.TotalIndividual}}</b-button>
              </template>
              <template v-slot:cell(TotalGro  up)="data">
                <b-button
                  size="sm"
                  @click.stop="viewDetailsGR(data.item)"
                  class="mr-1 pt-0 pb-0"
                  variant="link"
                  v-b-tooltip.hover
                  title="View Details"
                >{{data.item.TotalGroup}}</b-button>
              </template>
                <template v-slot:cell(TotalEducation)="data">
                <b-button
                  size="sm"
                  @click.stop="viewDetailsEducation(data.item)"
                  class="mr-1 pt-0 pb-0"
                  variant="link"
                  v-b-tooltip.hover
                  title="View Details"
                >{{data.item.TotalEducation}}</b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="mt-2">
        <b-card v-if="RoleID ==3 || RoleID ==4 || RoleID ==5 || RoleID==10" md="10" no-body>
          <b-tabs card>
            <b-tab title="Applications">
              <b-row>
                <b-col md="10">
                  <b-form-radio-group
                    id="radio-group-loantype"
                    v-model="loanType"
                    @change.native="onLoanTypeChange"
                    name="radio-loan-type"
                  >
                    <b-form-radio value="0">All</b-form-radio>
                    <b-form-radio value="1">Individual Loan</b-form-radio>
                    <b-form-radio value="2">Group Loan</b-form-radio>
                    <b-form-radio value="3">Education Loan</b-form-radio>
                  </b-form-radio-group>
                </b-col>
                <b-col>
                  <b-button
                    size="sm"
                    class="mb-2 float-right"
                    variant="primary"
                    @click="doit('xlsx')"
                  >Excel</b-button>
                </b-col>
              </b-row>
              <b-table
                id="data-table"
                show-empty
                head-variant="dark"
                empty-text="No Applications available."
                stacked="md"
                bordered
                striped
                small
                sticky-header="200px"
                :items="appsummary"
                :fields="fieldsMD"
                style="font-size:12px"
              >
                <template v-slot:thead-top>
                  <b-tr>
                    <b-th colspan="2">
                      <span class="sr-only"></span>
                    </b-th>
                    <b-th variant="secondary" colspan="4">Pending with Corporation</b-th>
                    <b-th variant="primary" colspan="5">Pending with Applicant</b-th>
                    <b-th variant="danger" colspan="2">
                      <span class="sr-only"></span>
                    </b-th>
                  </b-tr>
                </template>

                <template v-slot:cell(DM)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'DM')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.DM}}</b-button>
                </template>

                <template v-slot:cell(DBSC)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'DBSC')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.DBSC}}</b-button>
                </template>

                <template v-slot:cell(Project)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Project')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Project}}</b-button>
                </template>

               <template v-slot:cell(DGM)="data">
                  <b-button
                    size="sm  "
                    @click.stop="viewDetails(data.item, 'DGM')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.DGM}}</b-button>
                </template>

                <template v-slot:cell(GM)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'GM')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.GM}}</b-button>
                </template>

                <!-- <template v-slot:cell(MD)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'MD')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.MD}}</b-button>
                </template> -->

                <template v-slot:cell(LOI)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'LOI')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.LOI}}</b-button>
                </template>

                <template v-slot:cell(Lapsed)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Lapsed')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Lapsed}}</b-button>
                </template>

                <template v-slot:cell(Disbursed)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Disbursed')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Disbursed}}</b-button>
                </template>

                <template v-slot:cell(Hold)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Hold')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Hold}}</b-button>
                </template>

                <template v-slot:cell(Rejected)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Rejected')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Rejected}}</b-button>
                </template>

                <template v-slot:cell(Total)="data">
                  <b-button
                    size="sm"
                    @click.stop="viewDetails(data.item, 'Total')"
                    class="mr-1 pt-0 pb-0"
                    variant="link"
                  >{{data.item.Total}}</b-button>
                </template>
              </b-table>
            </b-tab>
            <b-tab title="Claims">
              <b-col md="10">
                <b-form-radio-group
                  id="radio-group-claimloantype"
                  v-model="claimloantype"
                  @change="onClaimLoanTypeChange($event)"
                  name="radio-claimloan-type"
                >
                  <b-form-radio value="0">All</b-form-radio>
                  <b-form-radio value="1">Individual Loan</b-form-radio>
                  <b-form-radio value="2">Group Loan</b-form-radio>
                  <b-form-radio value="3">Education Loan</b-form-radio>
                </b-form-radio-group>
              </b-col>
              <b-col md="8">
                <claims-table ref="claimsTable" @ttl="setClaims"></claims-table>
              </b-col>
            </b-tab>
          </b-tabs>
        </b-card>
        <b-col v-if="RoleID ==6 || RoleID ==7" md="10">
          <b-col md="10">
            <b-form-radio-group
              id="radio-group-claimloantype"
              v-model="claimloantype"
              @change="onClaimLoanTypeChange($event)"
              name="radio-claimloan-type"
            >
              <b-form-radio value="0">All</b-form-radio>
              <b-form-radio value="1">Individual Loan</b-form-radio>
              <b-form-radio value="2">Group Loan</b-form-radio>
              <b-form-radio value="3">Education Loan</b-form-radio>
            </b-form-radio-group>
          </b-col>
          <claims-table ref="claimsTable" @ttl="setClaims"></claims-table>
        </b-col>
      </b-col>
      <b-col md="2">
        <b-card
          border-variant="primary"
          class="shadow rounded mt-3"
          header-border-variant="secondary"
          v-if="RoleID ==3 || RoleID ==4 || RoleID ==5"
          align="center"
        >
          <a href="#" @click.prevent="viewDBDetails">
            <h3 class="my-2">{{PendingCountLOI}}</h3>
            <p class="mb-3">{{PendingLabel}}</p>
          </a>
        </b-card>
        <br />
        <b-card
          border-variant="danger"
          class="shadow rounded"
          header-border-variant="secondary"
          v-if="RoleID ==6 || RoleID ==4 || RoleID ==5 || RoleID ==7"
          align="center"
        >
          <a href="#" @click.prevent="viewClaims(null, getDefaultClaimOwnerForRole(RoleID))">
            <h3 class="my-2">{{PendingCountClaim}}</h3>
            <p class="mb-3">Pending Claims Approval</p>
          </a>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import ClaimsTable from "@/components/Admin/ClaimsTable";
import XLSX from "xlsx";
import { TENANT_MAP, detectTenant, filterByCaste } from "@/tenantConfig";
import { normalizeResponseArray } from "@/utils/responseNormalizer";
export default {
  components: { Spinner, ClaimsTable },
  data() {
    return {
      RoleID: 2,
      districts: [],
      appsummary: [],
      appsummaryMD: [],
      schemes: [],
      fields: [
        { key: "ApplicationStatus", label: "Application Status" },
        { key: "TotalIndividual", label: "Individual" },
        { key: "TotalGroup", label: "Group" },
         { key: "TotalEducation", label: "Education" },
        { key: "PendingAt", label: "Pending At" }
      ],
      fieldsMD: [
        { key: "SL", label: "SL" },
        { key: "DistrictName", label: "District Name" },
        { key: "DM", label: "DM" },
        { key: "DBSC", label: "DBSC" },
        { key: "Project", label: "Project" },
        { key: "DGM", label: "DGM" },
        { key: "GM", label: "GM" },
        { key: "LOI", label: "LOI" },
        { key: "Lapsed", label: "Lapsed" },
        { key: "Disbursed", label: "Disbursed" },
        { key: "Hold", label: "Hold" },
        { key: "Rejected", label: "Rejected" },
        { key: "Total", label: "Total" },
        { Key: "Registrations", label: "Registrations" }
      ],
      selectedDistrict: "00000000-0000-0000-0000-000000000000",
      selectedScheme: "00000000-0000-0000-0000-000000000000",
      PendingCountClaim: 0,
      PendingCountLOI: 0,
      PendingLabel: "Pending MD Approvals",
      loanType: 0,
      claimloantype:0,
      schemeStatsLoading: false,
      schemeStats: {
        schemeWise: [],
        applicationStatusWise: [],
        categoryWise: [],
        claimSplit: { oldCount: 0, newCount: 0, oldAmount: 0, newAmount: 0 }
      },
      companyStatsLoading: false,
      supportsCompanyStatsApi: true,
      companyStatsApiDisabled: false,
      companyStatsRows: [],
      companyStatsFields: [
        { key: "CompanyType", label: "Type", sortable: true },
        { key: "CompanyName", label: "Company", sortable: true },
        { key: "TotalApplications", label: "Applications", sortable: true },
        { key: "LOIIssued", label: "LOI Issued", sortable: true },
        { key: "OldClaims", label: "Old Claims", sortable: true },
        { key: "NewClaims", label: "New Claims", sortable: true },
        { key: "TotalClaimAmount", label: "Claim Amount", sortable: true },
      ]
    };
  },
  computed: {
    userDistrict() {
      return this.$store.getters.getUserDistrict;
    }
  },
  methods: {
    formatAmount(value) {
      return (Number(value) || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    toMapRows(mapObj) {
      return Object.keys(mapObj)
        .map((k) => ({ label: k, count: mapObj[k] }))
        .sort((a, b) => b.count - a.count);
    },
    normalizeStatsList(rows, labelKeyCandidates, countKeyCandidates) {
      if (!Array.isArray(rows)) return [];
      return rows.map((r) => {
        var label = "";
        var count = 0;

        if (Array.isArray(r)) {
          label = (r[0] === undefined || r[0] === null || r[0] === "") ? "Unknown" : String(r[0]);
          count = parseInt(r[1], 10) || 0;
          return { label, count };
        }

        labelKeyCandidates.some((k) => {
          if (r[k] !== undefined && r[k] !== null && r[k] !== "") {
            label = String(r[k]);
            return true;
          }
          return false;
        });

        countKeyCandidates.some((k) => {
          if (r[k] !== undefined && r[k] !== null && r[k] !== "") {
            count = parseInt(r[k], 10) || 0;
            return true;
          }
          return false;
        });

        return { label: label || "Unknown", count };
      }).sort((a, b) => b.count - a.count);
    },
    normalizeStatsPayload(payload) {
      if (Array.isArray(payload)) {
        return {
          schemeWise: payload[0] || [],
          applicationWise: payload[1] || [],
          categoryWise: payload[2] || [],
          casteWise: payload[3] || [],
          genderWise: payload[4] || [],
          claimSplit: payload[5] || [],
          yearWise: payload[6] || [],
          officeWise: payload[7] || [],
          beneficiarySplit: payload[8] || [],
        };
      }

      if (payload && typeof payload === "object") {
        if (payload.schemeWise !== undefined || payload.applicationWise !== undefined) {
          return payload;
        }

        const tableKeys = Object.keys(payload)
          .filter((k) => Array.isArray(payload[k]))
          .sort((a, b) => {
            const aNum = a === "Table" ? 0 : parseInt(String(a).replace("Table", ""), 10);
            const bNum = b === "Table" ? 0 : parseInt(String(b).replace("Table", ""), 10);
            const aVal = Number.isNaN(aNum) ? Number.MAX_SAFE_INTEGER : aNum;
            const bVal = Number.isNaN(bNum) ? Number.MAX_SAFE_INTEGER : bNum;
            return aVal - bVal;
          });

        if (tableKeys.length > 0) {
          const arr = tableKeys.map((k) => payload[k]);
          return {
            schemeWise: arr[0] || [],
            applicationWise: arr[1] || [],
            categoryWise: arr[2] || [],
            casteWise: arr[3] || [],
            genderWise: arr[4] || [],
            claimSplit: arr[5] || [],
            yearWise: arr[6] || [],
            officeWise: arr[7] || [],
            beneficiarySplit: arr[8] || [],
          };
        }
      }

      return payload || {};
    },
    getCompanyStatDefinitions() {
      return Object.keys(TENANT_MAP)
        .map((key) => TENANT_MAP[key])
        .sort((a, b) => {
          if (a.isParent && !b.isParent) return -1;
          if (!a.isParent && b.isParent) return 1;
          return String(a.nameMarathi || a.nameEnglish || "").localeCompare(String(b.nameMarathi || b.nameEnglish || ""));
        });
    },
    buildCompanyStatsRow(company, statsPayload) {
      const stats = this.normalizeStatsPayload(statsPayload || {});
      const schemeWise = this.normalizeStatsList(stats.schemeWise, ["Scheme"], ["TotalApplications"]);
      const statusWise = this.normalizeStatsList(stats.applicationWise, ["ApplicationStatus"], ["TotalApplications"]);
      const totalApplications = schemeWise.reduce((sum, row) => sum + (row.count || 0), 0);
      const loiIssued = statusWise
        .filter((row) => String(row.label || "").toLowerCase().indexOf("loi") !== -1)
        .reduce((sum, row) => sum + (row.count || 0), 0);

      const claimTotals = { oldCount: 0, newCount: 0, oldAmount: 0, newAmount: 0 };
      if (Array.isArray(stats.claimSplit)) {
        stats.claimSplit.forEach((c) => {
          const type = Array.isArray(c) ? String(c[0] || "").toLowerCase() : String(c.ClaimType || "").toLowerCase();
          const count = Array.isArray(c) ? (parseInt(c[1], 10) || 0) : (parseInt(c.TotalClaims, 10) || 0);
          const amount = Array.isArray(c) ? (parseFloat(c[2]) || 0) : (parseFloat(c.TotalClaimAmount) || 0);
          if (type === "new") {
            claimTotals.newCount += count;
            claimTotals.newAmount += amount;
          } else {
            claimTotals.oldCount += count;
            claimTotals.oldAmount += amount;
          }
        });
      }

      return {
        CompanyType: company.isParent ? "Main Company" : "Subsidiary",
        CompanyName: company.nameMarathi || company.nameEnglish || company.tenantId,
        TotalApplications: totalApplications,
        LOIIssued: loiIssued,
        OldClaims: claimTotals.oldCount,
        NewClaims: claimTotals.newCount,
        TotalClaimAmount: this.formatAmount(claimTotals.oldAmount + claimTotals.newAmount),
      };
    },
    resetSchemeStats() {
      this.schemeStats = {
        schemeWise: [],
        applicationStatusWise: [],
        categoryWise: [],
        claimSplit: { oldCount: 0, newCount: 0, oldAmount: 0, newAmount: 0 }
      };
    },
    applySchemeStats(rows) {
      const schemeMap = {};
      const statusMap = {};
      const categoryMap = {};
      const claimSplit = { oldCount: 0, newCount: 0, oldAmount: 0, newAmount: 0 };

      (rows || []).forEach((row) => {
        const scheme = (row.Scheme || row.SchemeType || row.SchemeName || "Unspecified").toString().trim() || "Unspecified";
        const status = (row.ApplicationStatus || row.ApplicationStatus1 || "Unspecified").toString().trim() || "Unspecified";
        const category = (row.Category || row.CategoryName || "Unspecified").toString().trim() || "Unspecified";

        schemeMap[scheme] = (schemeMap[scheme] || 0) + (parseInt(row.TotalApplications, 10) || 0);
        statusMap[status] = (statusMap[status] || 0) + (parseInt(row.TotalApplications, 10) || 0);
        categoryMap[category] = (categoryMap[category] || 0) + (parseInt(row.TotalApplications, 10) || 0);

        const claimType = String(row.ClaimType || "").toLowerCase();
        const claimCount = parseInt(row.TotalClaims || row.TotalApplications || 0, 10) || 0;
        const claimAmount = parseFloat(row.TotalClaimAmount || row.ClaimAmount || 0) || 0;
        if (claimType === "new") {
          claimSplit.newCount += claimCount;
          claimSplit.newAmount += claimAmount;
        } else if (claimType === "old") {
          claimSplit.oldCount += claimCount;
          claimSplit.oldAmount += claimAmount;
        }
      });

      this.schemeStats = {
        schemeWise: this.toMapRows(schemeMap),
        applicationStatusWise: this.toMapRows(statusMap),
        categoryWise: this.toMapRows(categoryMap),
        claimSplit
      };
    },
    shouldSkipCompanyStatsApi() {
      return this.companyStatsApiDisabled || !this.supportsCompanyStatsApi;
    },
    getSchemeStatistics() {
      this.schemeStatsLoading = true;
      this.resetSchemeStats();

      if (this.shouldSkipCompanyStatsApi()) {
        this.schemeStatsLoading = false;
        return Promise.resolve();
      }

      const userDistrict = this.$store.getters.getUserDistrict;
      const districtID = (userDistrict && userDistrict !== "00000000-0000-0000-0000-000000000000")
        ? userDistrict
        : this.$store.getters.getDistrict;

      return apis.ReadCompanyStatisticsSplit({
        DistrictID: districtID || "00000000-0000-0000-0000-000000000000",
        LoanType: 0,
        StartDate: "1970-01-01",
        EndDate: "2099-12-31",
        IsSpecializedCompany: false,
        EffectiveFromDate: null,
        CasteCodesCsv: null,
        CasteNamesCsv: null
      })
        .then((response) => {
          const body = response && (response.body || response.data) ? (response.body || response.data) : null;
          const rows = body ? normalizeResponseArray(body) : [];
          this.applySchemeStats(rows);
        })
        .catch((err) => {
          const status = err && typeof err.status === 'number' ? err.status : 0;
          const message = err && (err.message || "");
          const isBadRequest = status === 400;
          const isMissingEndpoint = status === 404 || String(message).toLowerCase().indexOf("not found") !== -1;
          if (isBadRequest || isMissingEndpoint) {
            this.supportsCompanyStatsApi = false;
            this.companyStatsApiDisabled = true;
          }
          this.resetSchemeStats();
        })
        .finally(() => {
          this.schemeStatsLoading = false;
        });
    },
    getCompanyWiseStatistics() {
      this.companyStatsLoading = true;

      if (this.shouldSkipCompanyStatsApi()) {
        this.companyStatsLoading = false;
        this.companyStatsRows = [];
        return Promise.resolve();
      }

      const userDistrict = this.$store.getters.getUserDistrict;
      const districtID = (userDistrict && userDistrict !== "00000000-0000-0000-0000-000000000000")
        ? userDistrict
        : (this.selectedDistrict || this.$store.getters.getDistrict || "00000000-0000-0000-0000-000000000000");

      return Promise.all(this.getCompanyStatDefinitions().map((company) => {
        const casteCodesCsv = (company.castes || [])
          .map((c) => c.casteCode)
          .filter((c) => Number(c) > 0)
          .join(",");
        const casteNamesCsv = (company.castes || [])
          .map((c) => c.casteName)
          .filter((c) => c && c.toString().trim() !== "")
          .join(",");

        return apis.ReadCompanyStatisticsSplit({
          DistrictID: districtID,
          LoanType: 0,
          StartDate: "1970-01-01",
          EndDate: "2099-12-31",
          IsSpecializedCompany: String(company.type || "").trim().toLowerCase() === "specialized",
          EffectiveFromDate: company.establishmentDate || null,
          CasteCodesCsv: casteCodesCsv || null,
          CasteNamesCsv: casteNamesCsv || null,
        }).then((response) => {
          let body = response && (response.body || response.data) ? (response.body || response.data) : null;
          if (typeof body === "string") {
            try {
              body = JSON.parse(body);
            } catch (e) {
              body = null;
            }
          }
          return this.buildCompanyStatsRow(company, body || {});
        }).catch((err) => {
          const status = err && typeof err.status === 'number' ? err.status : 0;
          const message = err && (err.message || "");
          const isBadRequest = status === 400;
          const isMissingEndpoint = status === 404 || String(message).toLowerCase().indexOf("not found") !== -1;
          if (isBadRequest || isMissingEndpoint) {
            this.supportsCompanyStatsApi = false;
            this.companyStatsApiDisabled = true;
          }
          return this.buildCompanyStatsRow(company, {});
        });
      }))
        .then((rows) => {
          this.companyStatsRows = rows;
        })
        .catch(() => {
          this.companyStatsRows = [];
        })
        .finally(() => {
          this.companyStatsLoading = false;
        });
    },
    doit(type, fn, dl) {
      var elt = document.getElementById("data-table").cloneNode(true);
      //Create a HTML Table element.
      var table = document.createElement("TABLE");
      table.border = "1";

      //Add the header row.
      var row = table.insertRow(-1);
      let headerCell = document.createElement("TH");
      headerCell.innerHTML =
        "महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित";
      // headerCell.append("<p>वैयक्तिक कर्ज व्याज परतावा</p>");
      headerCell.colSpan = 13;
      headerCell.style.textAlign = "center";
      row.appendChild(headerCell);

      var row2 = table.insertRow(-1);
      let headerCell2 = document.createElement("TH");
      if (this.loanType == 1) {
        headerCell2.innerHTML = " कर्ज व्याज परतावा योजना प्रकरणांचा तपशील";
      } else if (this.loanType == 2) {
        headerCell2.innerHTML = "गट कर्ज व्याज परतावा योजना प्रकरणांचा तपशील";
      } else {
        headerCell2.innerHTML =
          "वैयक्तिक व गट कर्ज व्याज परतावा योजना, प्रकरणांचा तपशील";
      }

      headerCell2.colSpan = 8;
      headerCell2.style.textAlign = "center";
      row2.appendChild(headerCell2);

      let headerCell3 = document.createElement("TH");

      var n = new Date();
      headerCell3.innerHTML = n.toLocaleString("hi-IN");

      var x = elt.querySelectorAll("tr");
      headerCell3.style.textAlign = "right";
      headerCell3.colSpan = 5;
      row2.appendChild(headerCell3);

      var i;
      for (i = 0; i < x.length; i++) {
        table.appendChild(x[i]);
      }

      fn =
        "ApplicationSummary_" +
        n
          .toLocaleString("tr-TR")
          .replace(".", "")
          .replace(".", "")
          .replace(" ", "")
          .replace(":", "")
          .replace(":", "") +
        ".xlsx";
      var wb = XLSX.utils.table_to_book(table, {
        sheet: "Application_Summary"
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "ApplicationSummary." + (type || "xlsx"));
    },
    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.districts.unshift({
              DistID: "00000000-0000-0000-0000-000000000000",
              DistName: "All"
            });
            this.selectedDistrict = this.$store.getters.getUserDistrict;

            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    onChangeDistrict(evt) {
      this.selectedDistrict = evt.target.value;
      this.getSummary();
      this.getSchemeStatistics();
      this.getCompanyWiseStatistics();
    },
    onLoanTypeChange() {
      this.getSummary();
    },
    onClaimLoanTypeChange(loanType) {
      const selectedLoanType = Number(loanType);
      this.claimloantype = selectedLoanType;
      const claimTable = this.$refs.claimsTable;

      if (claimTable && claimTable.getClaimSummary) {
        claimTable.getClaimSummary(selectedLoanType);
      }
    },
    updatePendingCounts() {
      var ttl = this.appsummary.filter(function(r) { return r.DistrictName === "TOTAL"; });
      if (ttl.length > 0) {
        if (this.RoleID == 4) {
          this.PendingCountLOI = ttl[0].MD;
          this.PendingLabel = "Pending MD Approval";
        } else if (this.RoleID == 5) {
          this.PendingCountLOI = ttl[0].GM;
          this.PendingLabel = "Pending GM Approval";
        } else if (this.RoleID == 3) {
          this.PendingCountLOI = ttl[0].Project;
          this.PendingLabel = "Pending AGM Approval";
        }
      }
    },
    getSummary() {
      if (this.userDistrict != "00000000-0000-0000-0000-000000000000") {
        this.selectedDistrict = this.userDistrict;
      }

      var promise;
      var isDistrictView = false;
      if (this.RoleID !== 3 && this.RoleID != 4 && this.RoleID != 5 && this.RoleID != 10) {
        promise = apis.getApplicationSummary(this.selectedDistrict);
        isDistrictView = false;
      } else if (this.RoleID == 3 || this.RoleID == 4 || this.RoleID == 5 || this.RoleID == 10) {
        promise = apis.getApplicationSummaryMD(this.loanType);
        isDistrictView = true;
      } else {
        return;
      }

      var self = this;
      var tenant = detectTenant();

      promise
        .then(function(response) {
          if (response.status == 200) {
            var summaryData = response.body;

            if (tenant.type === "Specialized" && tenant.castes && tenant.castes.length > 0) {
              // For specialized sub-companies, fetch individual apps to compute caste ratios
              var lt = parseInt(self.loanType) || 0;
              var loanTypes = (lt === 0) ? [1, 2, 3] : [lt];
              var districtID = isDistrictView ? "00000000-0000-0000-0000-000000000000" : self.selectedDistrict;
              var fetchPromises = loanTypes.map(function(t) {
                return apis.ReadApplicationList({
                  DistrictID: districtID,
                  ApplicationStatusID: 0,
                  LoanType: t,
                  MobileNo: "",
                  ApplicationNo: "",
                  StartDate: "01-01-1970",
                  EndDate: "01-01-1970"
                });
              });

              Promise.all(fetchPromises).then(function(responses) {
                var allApps = [];
                responses.forEach(function(r) {
                  if (r.status == 200 && Array.isArray(r.body)) {
                    allApps = allApps.concat(r.body);
                  }
                });

                var filteredApps = filterByCaste(allApps, tenant);

                if (isDistrictView) {
                  // RoleID 3/4/5/10: district-wise summary — scale by ratio per district
                  var totalPerDistrict = {};
                  var filteredPerDistrict = {};

                  allApps.forEach(function(app) {
                    var dist = (app.DistrictName || "").trim();
                    if (dist) totalPerDistrict[dist] = (totalPerDistrict[dist] || 0) + 1;
                  });
                  filteredApps.forEach(function(app) {
                    var dist = (app.DistrictName || "").trim();
                    if (dist) filteredPerDistrict[dist] = (filteredPerDistrict[dist] || 0) + 1;
                  });

                  var columns = ["DM", "DBSC", "Project", "DGM", "GM", "LOI", "Lapsed", "Disbursed", "Hold", "Rejected", "Total"];

                  self.appsummary = summaryData.map(function(row) {
                    var dist = (row.DistrictName || "").trim();
                    if (dist === "TOTAL") return row; // recompute after
                    var total = totalPerDistrict[dist] || 0;
                    var filtered = filteredPerDistrict[dist] || 0;
                    var ratio = total > 0 ? filtered / total : 0;
                    var newRow = {};
                    for (var key in row) { newRow[key] = row[key]; }
                    columns.forEach(function(col) {
                      newRow[col] = Math.round((row[col] || 0) * ratio);
                    });
                    return newRow;
                  });

                  // Recompute TOTAL row
                  for (var i = 0; i < self.appsummary.length; i++) {
                    if ((self.appsummary[i].DistrictName || "").trim() === "TOTAL") {
                      columns.forEach(function(col) {
                        var sum = 0;
                        self.appsummary.forEach(function(row) {
                          if ((row.DistrictName || "").trim() !== "TOTAL") sum += (row[col] || 0);
                        });
                        self.appsummary[i][col] = sum;
                      });
                      break;
                    }
                  }
                } else {
                  // RoleID 2: status-wise summary — scale Individual/Group/Education by ratio per loan type
                  var ratios = {};
                  [1, 2, 3].forEach(function(lt, idx) {
                    var apps = (responses[idx] && responses[idx].status == 200 && Array.isArray(responses[idx].body)) ? responses[idx].body : [];
                    var filt = filterByCaste(apps, tenant);
                    ratios[lt] = apps.length > 0 ? filt.length / apps.length : 0;
                  });
                  self.appsummary = summaryData.map(function(row) {
                    var newRow = {};
                    for (var key in row) { newRow[key] = row[key]; }
                    newRow.TotalIndividual = Math.round((row.TotalIndividual || 0) * ratios[1]);
                    newRow.TotalGroup = Math.round((row.TotalGroup || 0) * ratios[2]);
                    newRow.TotalEducation = Math.round((row.TotalEducation || 0) * ratios[3]);
                    return newRow;
                  });
                }

                self.updatePendingCounts();
                self.isLoading = false;
              }).catch(function() {
                // Fallback: use original summary data if fetch fails
                self.appsummary = summaryData;
                self.updatePendingCounts();
                self.isLoading = false;
              });
            } else {
              // Universal tenant — use original data unchanged
              self.appsummary = summaryData;
              self.updatePendingCounts();
              self.isLoading = false;
            }
          } else {
            self.alertText = response.body;
            self.variant = "warning";
            self.showDismissibleAlert = true;
          }
        })
        .catch(function(err) {
          self.alertText = err.message;
          self.showDismissibleAlert = true;
          self.variant = "danger";
        });
    },
    viewDBDetails() {
      let sts = 30;
      let statusBucket = "DGM";
      if (this.RoleID == 4) {
        // DGM reviews applications recommended by AGM.
        sts = 13;
        statusBucket = null;
      } else if (this.RoleID == 3) {
        sts = 13;
        statusBucket = "Project";
      }
      this.$store.dispatch(
        "setDistrict",
        "00000000-0000-0000-0000-000000000000"
      );
      this.$store.dispatch("setAppStatus", sts);
      this.$store.dispatch("setLoanType", 1);
      this.$store.dispatch("setSearchForm", {});
      this.$store.commit("SET_SEARCH_FORM", {});

      this.$router.push({
        name: "Applications",
        params: {
          userDistrictID: "00000000-0000-0000-0000-000000000000",
          userApprovalStatus: sts,
          userLoanType: 1,
          statusBucket: statusBucket
        }
      });
    },
    getDefaultClaimOwnerForRole(roleId) {
      switch (Number(roleId || 0)) {
        case 6:
          return "Accounts";
        case 5:
          return "GM";
        case 4:
          return "MD";
        case 7:
          return "Auditor";
        default:
          return "All";
      }
    },
    viewClaims(item, sts) {
      this.$store.dispatch("setDistrict", "00000000-0000-0000-0000-000000000000");
      this.$store.dispatch("setAppStatus", 0);
      this.$store.dispatch("setStatusOwner", sts || this.getDefaultClaimOwnerForRole(this.RoleID));
      this.$store.dispatch("setLoanType", Number(this.claimloantype || 1));
      this.$router.push("/approveclaims");
    },
    resolveDistrictIdForDrilldown(item) {
      var allDistrictId = "00000000-0000-0000-0000-000000000000";
      if (!item) {
        return this.selectedDistrict || allDistrictId;
      }

      var districtId = item.DistrictID || item.DistrictId || item.DistID;
      if (districtId) {
        return districtId;
      }

      var districtName = (item.DistrictName || item.District || item.DistName || "").toString().trim().toLowerCase();
      if (!districtName || districtName === "total" || districtName === "all") {
        return allDistrictId;
      }

      var matched = (this.districts || []).find(function(d) {
        return d && d.DistName && d.DistName.toString().trim().toLowerCase() === districtName;
      });

      return matched && matched.DistID
        ? matched.DistID
        : (this.selectedDistrict || allDistrictId);
    },
    viewDetails(item, type) {
      let sts = 1;
      var drilldownDistrictId = this.resolveDistrictIdForDrilldown(item);
      this.$store.dispatch("setDistrict", drilldownDistrictId);
      switch (type) {
        case "DM":
          sts = 1;
          break;
        case "DBSC":
          sts = 2;
          break;
        case "Project":
          sts = 13;
          break;
        case "DGM":
          // Pending-at-DGM queue = applications recommended by AGM, awaiting DGM action.
          sts = 4;
          break;
        case "GM":
          sts = 30;
          break;
        case "MD":
          sts = 6;
          break;
        case "LOI":
          sts = 9;
          break;
        case "Lapsed":
          sts = 10;
          break;
        case "Disbursed":
          sts = 22;
          break;
        case "Hold":
          sts = 3;
          break;
        case "Rejected":
          sts = 18;
          break;
        case "Total":
          sts = 16;
          break;
      }
      this.$store.dispatch("setAppStatus", sts);
      this.$store.dispatch("setLoanType", 1);
      this.$store.dispatch("setSearchForm", {});
      if(this.loanType==0)
      this.loanType=1;
      this.$router.push({
        name: "Applications",
        params: {
          userDistrictID: drilldownDistrictId,
          userApprovalStatus: sts,
          userLoanType: this.loanType,
          statusBucket: type === "LOI" ? "LOI" : null
        }
      });
    },

    viewDetailsIR(item, index) {
      if (item.Id > 0) {
        this.$store.dispatch("setDistrict", this.selectedDistrict);
        this.$store.dispatch("setAppStatus", item.Id);
        this.$store.dispatch("setLoanType", 1);
        this.$store.dispatch("setSearchForm", {});
        this.$router.push({
          name: "Applications",
          params: {
            userDistrictID: this.selectedDistrict,
            userApprovalStatus: item.Id,
            userLoanType: 1
          }
        });
      }
    },
    viewDetailsGR(item) {
      this.$store.dispatch("setDistrict", this.selectedDistrict);
      this.$store.dispatch("setAppStatus", item.Id);
      this.$store.dispatch("setLoanType", 2);
      this.$store.dispatch("setSearchForm", {});
      this.$router.push({
          name: "Applications",
          params: {
            userDistrictID: this.selectedDistrict,
            userApprovalStatus: item.Id,
            userLoanType: 2
          }
        });
    },
    viewDetailsEducation(item) {
      this.$store.dispatch("setDistrict", this.selectedDistrict);
      this.$store.dispatch("setAppStatus", item.Id);
      this.$store.dispatch("setLoanType", 2);
      this.$store.dispatch("setSearchForm", {});
      this.$router.push({
          name: "Applications",
          params: {
            userDistrictID: this.selectedDistrict,
            userApprovalStatus: item.Id,
            userLoanType: 3
          }
        });
    },
    setClaims(accountsCount, dgmCount, gmCount, mdCount) {
      switch (this.RoleID) {

        case 6:
          this.PendingCountClaim = accountsCount;
          break;
        case 5:
          this.PendingCountClaim = gmCount;
          break;
        case 4:
          this.PendingCountClaim = mdCount;
          break;
      }
    }
  },
  mounted() {

    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.RoleID = this.$store.getters.loggedUser.RoleID;
    this.getSchemeStatistics();
    this.getCompanyWiseStatistics();
    if (this.RoleID != 6) {
      this.getSummary();
    }
  }
};
</script>

<style scoped>
.dashboard-stats-card {
  border: 1px solid #d9e2ef;
}

.stat-title {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #2e4b90;
}

.stat-row {
  font-size: 12px;
  line-height: 1.5;
}
</style>

<style>
</style>






// WEBPACK FOOTER //
// src/components/Admin/AdminDashboard.vue